<template>
  <div>
    <div class="other-banner">
      <div class="w-default center">
        <ul class="crumb">
          <li>首页</li>
          <li>智慧安防解决方案</li>
        </ul>
        <h1>智慧安防解决方案</h1>
      </div>
    </div>
    <div class="introduction-row">
      <div class="w-default d-flex flex-colum ai-center">
        <h2>智慧安防解决方案</h2>
        <p>
          智慧安防综合业务管理平台是以视频为核心，网络为纽带，运用互联网思维和技术、云计算、大数据分析、智能技术等集成的综合业务管理平台。它基于统一规范整合视频监控、消防报警、能源安全、视频会议、人脸识别、智能分析、门禁、停车场、传感器及其他第三方系统，实现跨地区、跨网络、跨系统信息资源的整合共享和互联互通互控。
        </p>
        <!-- <button></button> -->
      </div>
    </div>
    <div class="article-row w-default" id="article">
      <article v-show="isActive2 == '1-1'">
        <h1 class="mb-30">应用场景</h1>
        <!-- <h3>1）安防运维系统</h3>
        <p class="mb-20">
          结合大数据、视频分析技术，智能发现安防系统存在的问题，并进行智能分析，实时告警，自动调整。例如当视频没有正常录制、录制不清晰时，智能定位问题，向管理人员进行告警，如果没有相关设置，系统自动根据配置进行自动调整。</p> -->
        <img class="mb-40 m-auto" src="../assets/img/SolutionSecurityAndProtection/eg2.png" alt="">
        <!-- <h3 class="mb-20">2）IT综合监控运维管理系统</h3> -->
        <img class="mb-20 m-auto" src="../assets/img/SolutionSecurityAndProtection/eg3.png" alt="">
        <img class="mb-20 m-auto" src="../assets/img/SolutionSecurityAndProtection/eg4.png" alt="">
        <!-- <h1 class="mb-30">产品特色</h1> -->
        <p>
          智慧安防综合业务管理平台广泛应用于各种场景，包括城市安全管理、企业安保、教育领域、住宅小区和物业管理等。它可以提高安全性、管理效率和响应能力，为人们提供一个更加安全、舒适的生活环境。主要核心优势体现在:
          <!-- <br />② 依托数据科学、人工智能等技术实现故障定位、趋势分析、提前预测故障、故障告警。
          <br />③ 自动化巡检、自动化运维。 -->
        </p>
        <h3>1）支持接入不限于视频、视图、10T、报警、门禁、道闸、巡更、广播对讲</h3>
        <h3>2）支持GB/T28181、GAT1400、JT/T1078、JT/T808、JT/T809、
          GB/T26875、智慧安防小区管理系统接口协议规范等</h3>
        <h3>3）支持以上所有协议上下级级联及非标转标准,标准转第三方接口</h3>
        <h3>4）平台支持免插件支持所有主流浏览器最大64画面实时预览</h3>
        <h3>5）支持RTSP、RTMP、http-flv、http-ws、hls视频协议分享,并支持浏
          览器地址直接预览或嵌入IFrame直接预览H264、H265视频,不卡顿</h3>
        <h3>6）支持H5、公众号、小程序、APP、浏览器、客户端全媒体展示</h3>
        <h3>7）支持OEM,平台完全自主研发,支持个性化应用需求开发</h3>
        <h3>8）支持国产化,满足信创要求</h3>
        <h3>9）支持根据项目需求自主选择购买模块、授权数量,减少用户前期投入,加速项目落地</h3>
        <h3>10）支持实况视频状态显示，设备类型、设备品牌、访问数量、发送字节数、接收字节数、句柄类型、句柄状态、句柄内容、句柄访问数、创建时间、更新时间、错误代码、描述、设备错误代码描述</h3>
        <img class="mb-20 m-auto" src="../assets/img/SolutionSecurityAndProtection/eg5.png" alt="">
        <img class="mb-20 m-auto" src="../assets/img/SolutionSecurityAndProtection/eg6.png" alt="">
        <h1 class="mb-30">方案架构</h1>
        <img class="mb-20 m-auto" src="../assets/img/SolutionSecurityAndProtection/eg7.png" alt="">


        <h1 class="mb-30">产品特色</h1>
        <!-- <h3>1）监控一体化</h3> -->
        <img class="m-auto" src="../assets/img/SolutionSecurityAndProtection/eg8.png" alt="">
        <!-- <h3>2）保障智能化</h3> -->
        <img class="m-auto" src="../assets/img/SolutionSecurityAndProtection/eg9.png" alt="">
        <!-- <h3>3）运维自动化</h3> -->
        <img class="m-auto" src="../assets/img/SolutionSecurityAndProtection/eg10.png" alt="">
        <img class="m-auto" src="../assets/img/SolutionSecurityAndProtection/eg11.png" alt="">
        <img class="m-auto" src="../assets/img/SolutionSecurityAndProtection/eg12.png" alt="">
        <img class="m-auto" src="../assets/img/SolutionSecurityAndProtection/eg13.png" alt="">
        <!-- <h3>4）准确的故障定位</h3> -->
        <P class="mb-20">人脸库功能：支持选择抓拍区域的摄像头，显示人员档案（如姓名、人员照片、性别）；支持档案合并功能；支持选择日期，
          输入姓名或身份证号查询；支持个人档案查询与编辑（包含：姓名、照片、性别、民族、籍贯、证件号码、电话
          、车牌号等）</P>
        <p class="mb-20">AR实景功能：支持添加AR摄像头做为至高点监控实景应用；支持设备类标签（如：门禁、摄像机、道闸、一键报警、
          广播音箱、可视对讲等设备）、支持公共区域标签（景点、重点区域、池塘、门口、广场、学校、其他建筑等）
          、支持场景信息标签（广场、停车场、设备间、机房、游泳池、楼栋等）；AR实景页面支持显示报警统计、维修 记录、设备状态信息；
        </p>
        <p class="mb-30"> 运维监测模块：支持设备概览显示（包括在线、离线、故障）；支持局域网内的监控设备统计，显示摄像头在线
          、离线状态；支持热门设备、登录统计，支持按品牌类型饼图或柱图显示、报警类型饼图或柱图显示、支持显示
          工单数量，支持态势显示（按周、按月、按年、自定义日期展示）</p>
        <h1 class="mb-30">泛接入功能</h1>
        <h3>
          1）视频监控设备：支持接入下级GB/T28181平台视频汇聚，支持向上级GB/T28181平台级联推送视频，支持接入下级GB/T1400平台视图汇聚，支持向上级GB/T1400平台级联推送送视图。支持海康威视/大华/高科/浙江宇视/华为/雄迈巨峰/天视通/汉邦高科/上海广拓/恒亿电子/大立/天地伟业/黄河/同创/艾普视达/中维世纪/敏达/荣天视等（局域网接入）品牌设备接入管理
        </h3>
        <h3>2）报警系统：Honeywell、C&K、BOSCH、Visonic、DSC、枫叶、普泰克、安居宝、华魏、时刻、安标、豪恩、从文、英安特</h3>
        <h3>3）门禁停车场系统：中控、纽贝尔、微耕、科松、PORIS、精工、富士、匹克、澳普、捷顺、博思高、达实</h3>
        <h3>4）IP对讲系统：来邦、世邦、恒通、奥智利、海康</h3>
        <h3>5）LED显示系统：诣阔、仰邦</h3>
        <h3>6）巡更系统：海康、大华、兰德华、中研</h3>
      </article>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      isActive1: 1,
      isActive2: "1-1"
    };
  },
  methods: {
    show(event) {
      let el = event.currentTarget.parentNode;
      console.log(el);
      let flag = (" " + el.className + " ").indexOf(" " + "show" + " ") > -1;
      if (flag) {
        el.classList.remove("show");
      } else {
        el.classList.add("show");
      }
    },
    active(page) {
      this.isActive1 = page.split("-")[0];
      this.isActive2 = page;
      document.getElementById("article").scrollIntoView();
    }
  }
};
</script>

<style lang="scss" scoped>
@import "../assets/scss/_variables.scss";

.other-banner {
  background: url("@/../../assets/img/banner/banner-index-2.jpg");
}

article {
  * {
    font-size: 16px;
  }

  flex: 1;

  .m-auto {
    margin-left: auto;
    margin-right: auto;
  }

  .mb-20 {
    margin-bottom: 20px;
  }

  .mb-30 {
    margin-bottom: 30px;
  }

  .mb-40 {
    margin-bottom: 40px;
  }

  .mb-60 {
    margin-bottom: 60px;
  }

  img {
    display: block;
    max-width: 100%;
  }

  h1 {
    font-size: 24px;
    border-left: 4px solid map-get($colors, "primary");
    padding-left: 14px;
    font-weight: bold;
  }

  h2 {
    line-height: 2;
  }

  h3 {
    line-height: 2;
  }

  p {
    line-height: 2;
  }
}
</style>
